import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import OptimizedImage from "./OptimizedImage";

const HomeSection3 = ({ section3, servicesInView, i18n }) => {

  return (
    <div>
      <div className="hero-wrapper position-relative">
        <section className="services py-5" style={Number(section3.use_bg_color) === 1 && section3.bg_color1 && section3.bg_color2 ? { background: `linear-gradient(to right, ${section3.bg_color1}, ${section3.bg_color2})` } : {}}>
          <div className="container">
            <div className="row text-end mb-5">
              <motion.h1
                className="mainHeading p-2"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}
              >
                {i18n.language === "en" ? section3.titleHeadEn : section3.titleHeadAr}
              </motion.h1>
            </div>

            <div className="row g-4">
              {section3?.cardData?.map((service, index) => {
                let colClass = "col-12 col-md-6";
                if (section3.cardData.length >= 4) colClass = "col-12 col-md-6 col-lg-3";
                return (
                  <motion.div
                    key={service.id}
                    className={colClass}
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: index * 0.2 }}
                  >
                    <div className="service-card position-relative" style={Number(service.use_color) === 1 && service.color1 && service.color2 ? { background: 'none', backgroundImage: `linear-gradient(to right, ${service.color1}, ${service.color2})` } : (service.color ? { backgroundColor: service.color } : {})}>
                      <div className="circle">
                        <OptimizedImage
                          src={
                            typeof service.icon === "string"
                              ? service.icon
                              : section3.icon || "/images/default.png"
                          }
                          alt={service.titleEn}
                          className="circleImage"
                          width={60}
                          height={60}
                        />
                      </div>
                      <h2 className="subHeading">
                        {i18n.language === "en" ? service.titleEn : service.titleAr}
                      </h2>
                      <p>{i18n.language === "en" ? service.descriptionEn : service.descriptionAr}</p>

                      {(section3.btnEn || section3.btnAr) && (
                        service.btnLink ? (
                          <NavLink to={service.btnLink} className="btnBlueCard text-decoration-none">
                            {i18n.language === "en"
                              ? section3.btnEn
                              : section3.btnAr}
                          </NavLink>
                        ) : (
                          <button className="btnBlueCard text-decoration-none" disabled>
                            {i18n.language === "en"
                              ? section3.btnEn
                              : section3.btnAr}
                          </button>
                        )
                      )}

                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </section>

        <div className="hero-decoration" style={{ bottom: "-23px" }}>
          <OptimizedImage src={require("../Images/Group 20.png")} alt="Decoration" width={160} height={40} />
        </div>
      </div>
    </div>
  );
};

export default HomeSection3;